export * from './bulk_mail.component';